const { getElement, getElements } = window.PURELEI.Utils

let dropdownLoaded = false

class HeaderDropdown extends window.PURELEI.CustomElement() {
    connectedCallback () {
        super.connectedCallback()

        this.lastTouched = null

        if (dropdownLoaded) return

        window.PURELEI.sectionRenderer
            .fetch(
                this.dataset.sectionId,
                `${window.Shopify.routes.root}?view=dropdown`,
            )
            .then((res) => {
                dropdownLoaded = true

                const newDOM = window.PURELEI.sectionRenderer.convertToDOM(
                    res[this.dataset.sectionId],
                )
                const myself = newDOM.querySelector(this.localName)

                this.outerHTML = myself.outerHTML
            })
            .catch(() => {})
    }

    setupListeners () {
        super.setupListeners()

        if (
            document.querySelector('[data-header-dropdown-el="menu-dropdown-toggle"]')
        ) {
            document.addEventListener(
                'click',
                this.handleToggleButtonClick.bind(this),
            )

            this.els?.item?.elements.forEach((itemEl) => {
                const menuDropdownEl = getElement(
                    '[data-header-dropdown-el="menu-dropdown"]',
                    { context: itemEl },
                )

                if (!menuDropdownEl) return

                const menuLinkEl = getElement('.hd-Banner_Link', { context: itemEl })

                this.listeners.add(
                    menuLinkEl,
                    'touchstart',
                    this.handleToggleButtonTouchStart,
                )
            })
        }

        document.addEventListener('focusin', this.handleFocusIn.bind(this))

        document.addEventListener('keyup', this.handleEscapePress.bind(this))
    }

    /**
     * @param {ClickEvent} event
     *
     * @returns {void}
     */
    handleToggleButtonTouchStart (event) {
        if (this.lastTouched === this.innerText) return

        event.preventDefault()

        this.lastTouched = this.innerText
    }

    /**
     * @param {ClickEvent} event
     *
     * @returns {void}
     */
    handleToggleButtonClick (event) {
        if (
            !event.target.closest('[data-header-dropdown-el="menu-dropdown-toggle"]')
        ) {
            return
        }

        const menuToggleEl = event.target
        const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)
        if (!parentItemEl) return
        const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
            context: parentItemEl,
        })

        if (!menuDropdownEl) return

        const isExpanded = menuDropdownEl.getAttribute('aria-expanded') === 'true'

        if (isExpanded) {
            menuToggleEl.removeAttribute('data-active')
            menuDropdownEl.removeAttribute('aria-expanded')
        } else {
            menuToggleEl.setAttribute('data-active', String(!isExpanded))
            menuDropdownEl.setAttribute('aria-expanded', String(!isExpanded))
        }
    }

    /**
     * @param {FocusInEvent} event
     *
     * @returns {void}
     */
    handleFocusIn (event) {
        if (
            event.target.closest(this.localName) &&
            !event.target.closest('[aria-expanded="true"]')
        ) {
            /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
            this.closeDropdowns()
        }

        if (!event.target.closest(this.localName)) {
            /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
            this.closeDropdowns()
        }
    }

    /**
     * @param {KeyboardEvent} event
     *
     * @returns {void}
     */
    handleEscapePress (event) {
        if (event.code?.toUpperCase() !== 'ESCAPE') return
        this.closeDropdowns()
    }

    /**
     * @returns {void}
     */
    closeDropdowns () {
        getElements('[data-header-dropdown-el="menu-dropdown-toggle"]').forEach(
            (menuDropdownEl) => {
                menuDropdownEl.removeAttribute('data-active')
            },
        )

        getElements('[data-header-dropdown-el="menu-dropdown"]').forEach(
            (menuDropdownEl) => {
                menuDropdownEl.removeAttribute('aria-expanded')
            },
        )
    }
}

if (!customElements.get('header-dropdown')) {
    customElements.define('header-dropdown', HeaderDropdown)
}
